import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBusSchedule = ({ bus_course_id, id, ...data }) => {
  return api.put(
    `/admin/bus-courses-v2/${bus_course_id}/schedules/${id}`,
    data
  );
};

export const usePutBusScheduleMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putBusSchedule,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: ["bus-schedules"],
      });
      queryClient.removeQueries({
        queryKey: ["put-bus-schedule-simulate"],
      });
    },
    ...restConfig,
  });
};
